<div class="subtotal">
    <div class="content">
        <p>Subtotal: <span style="float:right;">{{ (subtotal / 100).toFixed(2) }}</span></p>
        <p>Tax: <span style="float:right;">{{ (subtax / 100).toFixed(2) }}</span></p>
        <p>Shipping: <span style="float:right;">{{ (shippingCosts / 100).toFixed(2) }}</span></p>
        <!-- <p>International: <span style="float:right;">{{ (internationalCosts / 100).toFixed(2) }}</span></p> -->
        <span style="width: 100%; display: block; border-top: 1px solid black"></span>
        <p><b>Total: <span style="float:right;">{{ (amount / 100).toFixed(2) }}</span></b></p>
    </div>
</div>




<div class="globalContent">

    <main>
        <section class="container-lg">

            <!--Example 5-->
            <div class="cell example example5" #stripeContainer>
                <form ngNativeValidate>
                    <fieldset>
                        <legend class="card-only" data-tid="elements_examples.form.pay_with_card">Pay with card</legend>
                        <div class="row">
                            <div class="field">
                                <label for="example5-name" data-tid="elements_examples.form.name_label">Name</label>
                                <input id="example5-name" data-tid="elements_examples.form.name_placeholder"
                                    class="input" type="text" placeholder="Jane Doe" required="">
                            </div>
                        </div>
                        <div class="row">
                            <div class="field">
                                <label for="example5-email" data-tid="elements_examples.form.email_label">Email</label>
                                <input id="example5-email" data-tid="elements_examples.form.email_placeholder"
                                    class="input" type="text" placeholder="janedoe@gmail.com" required="">
                            </div>
                            <div class="field">
                                <label for="example5-phone" data-tid="elements_examples.form.phone_label">Phone</label>
                                <input id="example5-phone" data-tid="elements_examples.form.phone_placeholder"
                                    class="input" type="text" placeholder="(941) 555-0123" required="">
                            </div>
                        </div>
                        <div data-locale-reversible>
                            <div class="row">
                                <div class="field">
                                    <label for="example5-address"
                                        data-tid="elements_examples.form.address_label">Shipping Address</label>
                                    <input id="example5-address" data-tid="elements_examples.form.address_placeholder"
                                        class="input" type="text" placeholder="185 Berry St" required="">
                                </div>
                            </div>
                            <div class="row" data-locale-reversible>
                                <div class="field">
                                    <label for="example5-city" data-tid="elements_examples.form.city_label">City</label>
                                    <input id="example5-city" data-tid="elements_examples.form.city_placeholder"
                                        class="input" type="text" placeholder="San Francisco" required="">
                                </div>
                                <div class="field">
                                    <label for="example5-state"
                                        data-tid="elements_examples.form.state_label">State</label>
                                    <input id="example5-state" data-tid="elements_examples.form.state_placeholder"
                                        class="input empty" type="text" placeholder="CA" required="">
                                </div>
                                <div class="field">
                                    <label for="example5-zip"
                                        data-tid="elements_examples.form.postal_code_label">ZIP</label>
                                    <input id="example5-zip" data-tid="elements_examples.form.postal_code_placeholder"
                                        class="input empty" type="text" placeholder="94107" required="">
                                </div>
                                <!-- <div class="field">
                                    <label for="example5-country"
                                        data-tid="elements_examples.form.country_label">Country</label>
                                    <input id="example5-country" data-tid="elements_examples.form.country_placeholder"
                                        class="input empty" type="text" placeholder="USA" required="">
                                </div> -->
                            </div>
                        </div>
                        <div class="row">
                            <div class="field">
                                <label for="example5-card" data-tid="elements_examples.form.card_label">Card</label>
                                <div id="example5-card" class="input"></div>
                            </div>
                        </div>
                        <button *ngIf="amount" type="submit" data-tid="elements_examples.form.pay_button">Pay
                            ${{ (amount / 100).toFixed(2) }}</button>
                        <button *ngIf="!amount" type="submit" data-tid="elements_examples.form.pay_button">Pay</button>

                    </fieldset>

                    <div *ngIf="errorvisible" class="error" role="alert"><svg xmlns="http://www.w3.org/2000/svg"
                            width="17" height="17" viewBox="0 0 17 17">
                            <path class="base" fill="#000"
                                d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z">
                            </path>
                            <path class="glyph" fill="#FFF"
                                d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z">
                            </path>
                        </svg>
                        <span class="message">{{error_message}}</span>
                    </div>
                </form>

                <div class="success">
                    <div class="icon">
                        <svg width="84px" height="84px" viewBox="0 0 84 84" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <circle class="border" cx="42" cy="42" r="40" stroke-linecap="round" stroke-width="4"
                                stroke="#000" fill="none"></circle>
                            <path class="checkmark" stroke-linecap="round" stroke-linejoin="round"
                                d="M23.375 42.5488281 36.8840688 56.0578969 64.891932 28.0500338" stroke-width="4"
                                stroke="#000" fill="none"></path>
                        </svg>
                    </div>
                    <h3 class="title" data-tid="elements_examples.success.title">Thanks for your order!</h3>
                    <p class="message"><span data-tid="elements_examples.success.message"><a *ngIf="confirmation"
                                [href]=confirmation.receipt_url target="_blank"
                                style="color: #cdd0f8; font-size: 14px; text-decoration: underline;">Click</a></span>
                        <span class="token"> to see your receipt</span></p>

                    <a class="reset" href="#" (click)="onReset($event)">
                        <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <path fill="#000000"
                                d="M15,7.05492878 C10.5000495,7.55237307 7,11.3674463 7,16 C7,20.9705627 11.0294373,25 16,25 C20.9705627,25 25,20.9705627 25,16 C25,15.3627484 24.4834055,14.8461538 23.8461538,14.8461538 C23.2089022,14.8461538 22.6923077,15.3627484 22.6923077,16 C22.6923077,19.6960595 19.6960595,22.6923077 16,22.6923077 C12.3039405,22.6923077 9.30769231,19.6960595 9.30769231,16 C9.30769231,12.3039405 12.3039405,9.30769231 16,9.30769231 L16,12.0841673 C16,12.1800431 16.0275652,12.2738974 16.0794108,12.354546 C16.2287368,12.5868311 16.5380938,12.6540826 16.7703788,12.5047565 L22.3457501,8.92058924 L22.3457501,8.92058924 C22.4060014,8.88185624 22.4572275,8.83063012 22.4959605,8.7703788 C22.6452866,8.53809377 22.5780351,8.22873685 22.3457501,8.07941076 L22.3457501,8.07941076 L16.7703788,4.49524351 C16.6897301,4.44339794 16.5958758,4.41583275 16.5,4.41583275 C16.2238576,4.41583275 16,4.63969037 16,4.91583275 L16,7 L15,7 L15,7.05492878 Z M16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 Z">
                            </path>
                        </svg>
                    </a>
                </div>
            </div>

        </section>
    </main>
</div>


<!-- <pre *ngIf="confirmation" style="max-width: 100%;">
{{ confirmation | json }}
</pre> -->